/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import type { State } from 'bucket/reducers';
import * as FoldersActions from 'bucket/actions/folders';
import * as UploadsActions from 'bucket/actions/uploads';
import {
  getAllFolders,
  getIsSaving,
  getIsRemoving,
} from 'bucket/reducers/folders';
import { getCountByFolder } from 'bucket/reducers/resources';
import { Segment, Message, Divider } from 'semantic-ui-react';
import FolderList from './components/FolderList';
import NewFolder from './components/NewFolder';

type Props = {
  folders?: List<BucketFolder>,
  resourcesCountByFolder: Map<number, number>,
  saveFolder: (name: string) => void,
  removeFolder: (folder: BucketFolder) => void,
  isSaving: boolean,
  isRemoving: boolean,
  uploadFile: (folder: BucketFolder, file: File) => void,
};

const mapStateToProps = (state: State) => ({
  folders: getAllFolders(state),
  resourcesCountByFolder: getCountByFolder(state),
  isSaving: getIsSaving(state),
  isRemoving: getIsRemoving(state),
});

const Folders = ({
  folders,
  resourcesCountByFolder,
  removeFolder,
  saveFolder,
  isSaving,
  uploadFile,
  isRemoving,
}: Props) => {
  const renderContent = () => {
    if (folders && folders.size) {
      // TODO: Batch action calls
      const uploadFiles = (folder, files) =>
        Array.prototype.forEach.call(files, (f: File) => uploadFile(folder, f));

      return (
        <FolderList
          folders={folders}
          resourcesCountByFolder={resourcesCountByFolder}
          onUploadFiles={uploadFiles}
          onRemove={removeFolder}
          isRemoving={isRemoving}
        />
      );
    }

    return <Message icon="info circle" header="Aucun dossier" />;
  };

  return (
    <Segment>
      <NewFolder onSubmit={saveFolder} isSubmitting={isSaving} />
      <Divider />
      {renderContent()}
    </Segment>
  );
};

export default connect(mapStateToProps, {
  saveFolder: FoldersActions.saveFolder,
  removeFolder: FoldersActions.removeFolder,
  uploadFile: UploadsActions.uploadFile,
})(Folders);



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folders/index.js